import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+ ');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || '0',
    bgColor: searchParams.get('bgColor') || 'rgba(0,0,0,0.0)',
    startFrom: parseInt(searchParams.get('startFrom') || '') || 1,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 4000,
    carousel: searchParams.get('carousel') || '0',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    oneLineDuration: searchParams.get('oneLineDuration')
      ? parseInt(searchParams.get('oneLineDuration') || '')
      : 4000,
    pauseBetweenMessages: searchParams.get('pauseBetweenMessages')
      ? parseInt(searchParams.get('pauseBetweenMessages') || '')
      : 400,
  };
};
